/**
 * Whether this browser shows a PDF inline — every page of it, in a frame (RESP-08).
 *
 * Android browsers and WebViews have no built-in PDF viewer, so a framed PDF stays blank; they say
 * so through `navigator.pdfViewerEnabled`. iPhone and iPad (any browser there is WebKit) report a
 * viewer but draw only a PDF's first page in a frame, with no way on to the next. Both get a link
 * to the device's own viewer instead; desktop browsers keep the inline frame.
 */

export interface PdfNavigator {
  pdfViewerEnabled?: boolean;
  userAgent: string;
  platform?: string;
  maxTouchPoints?: number;
}

export function canShowPdfInline(
  nav: PdfNavigator | undefined = typeof navigator === "undefined" ? undefined : navigator,
): boolean {
  if (!nav) return true;
  if (nav.pdfViewerEnabled === false) return false;
  // iPadOS asks for the desktop site by default: a "Mac" with a touch screen is an iPad.
  const appleTouch =
    /\b(iPhone|iPad|iPod)\b/.test(nav.userAgent) || (nav.platform === "MacIntel" && (nav.maxTouchPoints ?? 0) > 1);
  return !appleTouch;
}
